import { Suspense } from "react";
import Loader from "../loader/loader";

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const LazyLoader = (Component: any) => (props: any) => (
  <Suspense fallback={<Loader />}>
    <Component {...props} />
  </Suspense>
);

export default LazyLoader;
